import { Helmet } from 'react-helmet-async';

const ServicesPageHelmet = () => {
  return (
    <Helmet>
      {/* Title & Meta */}
      <title>Our Services - Velocent Global Secure Logistics</title>
      <meta
        name='description'
        content='Velocent Global offers specialized secure logistics services including secure storage, global valuables transportation, private client storage, long haul transportation, distribution solutions, custom clearance, secure vaults, bonded warehouses, and more. We also handle diamonds, jewelry, precious metals, bank notes, fine arts, and electronics with maximum security and discretion.'
      />
      <meta
        name='keywords'
        content='Velocent Global services, secure storage, private client storage, secure logistics, long haul transportation, distribution solutions, customs clearance, secure vaults, bonded warehouses, diamond logistics, jewelry logistics, precious metals transport, bank notes logistics, fine arts logistics, electronics transport'
      />

      {/* Open Graph */}
      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content='https://www.velocentglobal.com/services'
      />
      <meta
        property='og:title'
        content='Velocent Global - Secure Logistics & Specialized Services'
      />
      <meta
        property='og:description'
        content='Explore Velocent Global’s secure logistics services: from storage, long haul transportation, and distribution solutions to custom clearance, secure vaults, diamonds, jewelry, precious metals, fine arts, bank notes, and electronics.'
      />
      <meta
        property='og:image'
        content='https://www.velocentglobal.com/assets/images/favicon.png'
      />
      <meta property='og:site_name' content='Velocent Global' />
      <meta property='og:locale' content='en_US' />

      {/* Canonical */}
      <link rel='canonical' href='https://www.velocentglobal.com/services' />
    </Helmet>
  );
};

export default ServicesPageHelmet;
